import { render, staticRenderFns } from "./ManualSubmissionSummary.vue?vue&type=template&id=950e169a&scoped=true"
import script from "./ManualSubmissionSummary.vue?vue&type=script&lang=js"
export * from "./ManualSubmissionSummary.vue?vue&type=script&lang=js"
import style0 from "./ManualSubmissionSummary.vue?vue&type=style&index=0&id=950e169a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950e169a",
  null
  
)

export default component.exports